import * as React from "react";
import type { SVGProps } from "react";
const SvgEmbed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M5.293 16.429a1 1 0 0 0 1.414-1.414L6 15.722zM2.4 12.122l-.707-.707a1 1 0 0 0 0 1.414zm4.307-2.893a1 1 0 0 0-1.414-1.414L6 8.522zm12-1.414a1 1 0 1 0-1.414 1.414L18 8.522zm2.893 4.307.707.707a1 1 0 0 0 0-1.414zm-4.307 2.893a1 1 0 0 0 1.414 1.414L18 15.722zm-7.975 3.284a1 1 0 0 0 1.932.515l-.966-.257zM12 12.121l-.966-.26v.003zm2.764-6.418a1 1 0 0 0-1.932-.52l.966.26zM6 15.722l.707-.707-3.6-3.6-.707.707-.707.707 3.6 3.6zm-3.6-3.6.707.707 3.6-3.6L6 8.522l-.707-.707-3.6 3.6zm15.6-3.6-.707.707 3.6 3.6.707-.707.707-.707-3.6-3.6zm3.6 3.6-.707-.707-3.6 3.6.707.707.707.707 3.6-3.6zm-11.316 6.435.966.258 1.716-6.436L12 12.12l-.966-.257-1.716 6.435zM12 12.12l.965.26 1.799-6.678-.966-.26-.966-.26-1.798 6.678z"
    />
  </svg>
);
export default SvgEmbed;
